import { render, staticRenderFns } from "./WorkOrderUpgradePage.vue?vue&type=template&id=2b405cf2&scoped=true"
import script from "./WorkOrderUpgradePage.vue?vue&type=script&lang=js"
export * from "./WorkOrderUpgradePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b405cf2",
  null
  
)

export default component.exports